import script from "./TaskAndAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskAndAnswer.vue?vue&type=script&setup=true&lang=js"

import "./TaskAndAnswer.vue?vue&type=style&index=0&id=11364744&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11364744"]])

export default __exports__